/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Kind_Story1Inputs */

const vi_cmspage_kind_story1 = /** @type {(inputs: Cmspage_Kind_Story1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Câu chuyện`)
};

/**

* @param {Cmspage_Kind_Story1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_kind_story1 = /** @type {((inputs?: Cmspage_Kind_Story1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Kind_Story1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_kind_story1(inputs)
});
export { cmspage_kind_story1 as "cmsPage_kind_story" }